const VisibilityTracking = () => {
  return (
    <>
      <div id="js-gtm-article-visibility-0" className="visibility-tracking" style={{ top: '0%' }}>
      </div>

      <div id="js-gtm-article-visibility-25" className="visibility-tracking" style={{ top: '25%' }}>
      </div>

      <div id="js-gtm-article-visibility-50" className="visibility-tracking" style={{ top: '50%' }}>
      </div>

      <div id="js-gtm-article-visibility-75" className="visibility-tracking" style={{ top: '75%' }}>
      </div>

      <div id="js-gtm-article-visibility-100" className="visibility-tracking" style={{ top: '100%' }}>
      </div>
    </>
  );
}

export default VisibilityTracking;
